import React from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Catches WebGL / R3F mount failures so the shell does not hard-crash to a blank
 * play surface. Shows a calm retry instead of the CRA error overlay only.
 */
export class WebGlErrorBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  private retry = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      const message = this.state.error.message || 'WebGL';
      return (
        <div
          className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-4 bg-[#8ecae6] p-6 text-center"
          data-name="webgl-error"
        >
          <p className="font-display text-2xl font-bold text-white drop-shadow">
            Kunne ikke starte 3D-spillet
          </p>
          <p className="max-w-md font-body text-white/90">{message}</p>
          <button
            type="button"
            onClick={this.retry}
            className="min-h-[96px] rounded-2xl bg-white px-8 font-display text-xl font-bold text-[#6441A5] shadow"
          >
            Prøv igjen
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default WebGlErrorBoundary;
